import React, { useEffect, useState } from 'react'
import InputField from '../../components/InputField/InputField'
import Button from '../../components/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { changeForgotPassword, clearState, userSelector } from '../../reducer/userSlice';
import ErrorToast from '../../components/Toast/ErrorToast';
import SuccessToast from '../../components/Toast/SuccessToast';
import PageLoader from '../../components/loaders/PageLoader/PageLoader';

const ChangePassword = () => {

    //Template
    const passTemplate = {
        password: "",
        confirmPassword: ""
    }

    const [type1, setType1] = useState(false);
    const [type2, setType2] = useState(false);

    const [password, setPassword] = useState(passTemplate);
    const [passValidation, setPassValidation] = useState(passTemplate);

    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");
    const [isShowSuccess, setIsShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

  const { isFetching, isSuccess, isError, errorMessage, route, forgotPassSuccess } =
      useSelector(userSelector);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { token } = useParams();

    const handlePassChange = (e) => {
        setPassValidation(passTemplate);
        const { name, value } = e.target;
        setPassword(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validate = () => {
        for (const key in password) {
            if(!password[key]) {
                setPassValidation(prev => ({
                    ...prev,
                    [key]: "Please fill this field!"
                }));
                return true;
            }
        };

        if(password["confirmPassword"] !== password["password"]) {
            setPassValidation(prev => ({
                ...prev,
                confirmPassword: "Passwords do not match!"
            }));
            return true;
        };

        if(password["password"]?.length < 6) {
            setPassValidation(prev => ({
                ...prev,
                password: "Passwords should be atleast 6 digit long"
            }));
            return true;
        }
    };

    const handleSubmit = () => {
        if(!validate()) {
            const obj = {
                token,
                password: password["password"]
            }
            dispatch(changeForgotPassword(obj))
        }
    };

    const handleKeyPressSubmit = (e) => {
        if(e.key === "Enter") {
            if(!validate()) {
                const obj = {
                    token,
                    password: password["password"]
                }
                dispatch(changeForgotPassword(obj))
            }
        }
    };

    useEffect(() => {
      if(isSuccess) {
        setIsShowSuccess(true);
        setSuccessMessage("Password changed successfully!")
        setTimeout(() => {
          navigate("/login")
        },1000)
        dispatch(clearState());
      }
    },[isSuccess]);

    useEffect(() => {
      if(isError) {
        setIsShowError(true);
        setErrMessage(errorMessage);
        dispatch(clearState());
      }
    },[isError]);

  return (
    <>
    {isFetching && <PageLoader />}
    <ErrorToast
      show={isShowError}
      setShow={() => setIsShowError(false)}
      message={errMessage}
    />
      <SuccessToast
      show={isShowSuccess}
      setShow={() => setIsShowSuccess(false)}
      message={successMessage}
    />
    <div className="loginmainwrapper active">
        <div className="dashboardWrapper">
          <img src="/assets/icons/logo.svg" alt="" className='logo' />
          <div className="dashLoginWrapper">
            <div className="loginHeading">Create New Password</div>
            <div className="loginText mt10">Enter new password to successfully login  </div>

            <div className="inputFieldsBox">
              <InputField
                notImp={"notimp"}
                placeholder={"New Password"}
                name="password"
                type={type1 ? 'text' : 'password'}
                inputIcon={type1 ? 'viewIcon' : 'hideIcon'}
                img={'lock'}
                onEyeClick={() => setType1(prev => !prev)}
                value={password["password"]}
                onChange={handlePassChange}
                onKeyDown={handleKeyPressSubmit}
                errorMessage={passValidation["password"]}
              />
              <InputField
                notImp={"notimp"}
                placeholder={"Confirm Password"}
                name="confirmPassword"
                type={type2 ? 'text' : 'password'}
                inputIcon={type2 ? 'viewIcon' : 'hideIcon'}
                img={'lock'}
                onEyeClick={() => setType2(prev => !prev)}
                value={password["confirmPassword"]}
                onChange={handlePassChange}
                onKeyDown={handleKeyPressSubmit}
                errorMessage={passValidation["confirmPassword"]}
                />

            </div>

            <div className='flex-center loginButton'>
              <Button className={'BlueFillButton mt40'} name={'Confirm Password'} onClick={handleSubmit} />
            </div>

          </div>
          <div className="copyrightText mt20">Copyright@getprepped | Privacy Policy</div>
        </div>
      </div>
              </>
  )
}

export default ChangePassword
